/**
 * Created by toomasp on 31.07.2015.
 */

import $RouteConfig from "./RouteConfig";
import Deferred from "./Deferred";
import app from "./App";
import {config} from "./Config";
import {Cookies} from "./Cookies";
import debug from "./Debug";
import iframeChannel from "./IframeChannel";
import keyboard from "./Keyboard";
import mouse from "./Mouse";
import navi from "./Navi";
import scheduler from "./Scheduler";
import ui from "./UI";
import translator from "./Translator";
import util from "./Util";
import messenger from "./Messenger";
import {bootstrapper} from "./Bootstrapper";

// $RouteConfig needs to be global and
// cannot be injected via angular injector as
// it needs to be present long before injector is initialized.
window['$RouteConfig'] = $RouteConfig;


let moment = require('lib/moment/moment.js');
window['moment'] = moment;

// import gidUtil from './util/GIDUtil';
// import roleUtil from './util/RoleUtil';
// import personCodeValidator from './util/PersonCodeValidator';


export let application = angular.module('eservice.core.application', [])
    .value('$', $)
    .value('_', _)

    .value('app', app)
    .value('config', config)
    .service('cookies', Cookies)
    .value('debug', debug)
    .value('iframeChannel', iframeChannel)
    .value('keyboard', keyboard)
    .value('mouse', mouse)
    .value('navi', navi)
    .value('scheduler', scheduler)
    .value('ui', ui)
    .value('translator', translator)
    .value('util', util)
    .value('messenger', messenger)

    // .value('gidUtil', gidUtil)
    // .value('roleUtil', roleUtil)
    // .value('personCodeValidator', personCodeValidator)


    .value('Deferred', Deferred)
;

$(document).ready(() => bootstrapper.bootstrap(angular.module('eservice.application')));


// WEBPACK FOOTER //
// ./src/main/ui/core/application/application.ts